var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',[_c('Drawer')],1),_c('Navbar'),_c('v-main',{staticStyle:{"background-color":"var(--kf-canvas)"},attrs:{"app":""}},[_c('Body')],1),_c('SnakeBar'),_c('LogoutAlertDialog',{attrs:{"dialog":_vm.dialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }